angular
  .module('contrast.factory.common', [])
  .factory('CommonFactory', function ($http) {
    return {
      requestReset: function (user) {
        return $http.put('/Contrast/api/public/ng/password/' + user + '/reset')
      },
      updatePassword: function (user, token, password) {
        return $http.put(
          '/Contrast/api/public/ng/password/' + user + '/' + token + '/update',
          { password: password }
        )
      },
      getResetPolicy: function (user, token) {
        return $http.get(
          '/Contrast/api/public/ng/passwordpolicy/' + user + '/' + token
        )
      },
      getRegistrationPolicy: function (user, token) {
        return $http.get(
          '/Contrast/api/public/ng/passwordpolicy/' +
            user +
            '/' +
            token +
            '/register'
        )
      },
      getCustomSettings: function () {
        return $http.get('/Contrast/api/public/ng/settings')
      },
      getInformation: function () {
        return $http.get('/Contrast/api/public/ng/information')
      },
      getSaml: function (uid) {
        return $http.get('/Contrast/api/public/ng/saml/email/' + uid)
      },
      register: function (data) {
        return $http.post('/Contrast/api/public/ng/register', data)
      },
      getPublicSAMLMetadata: function () {
        return $http.get('/Contrast/api/public/ng/saml/public_node/metadata')
      },
      getPublicNodeUrl: function () {
        return $http.get('/Contrast/api/public/ng/saml/public_node/url')
      }
    }
  })
